<template>
  <div class="carousel-container" ref="carouselRef">
    <!-- Botão para navegar para o slide anterior -->
    <button 
      @click="prevSlide" 
      class="carousel-control prev-links" 
      :disabled="currentIndex === 0"
      :class="{ disabled: currentIndex === 0 }"
      aria-label="Previous slide"
    >
      <img class="setas-navegacao" src="@/assets/icons/seta-left.svg" alt="Seta para a esquerda" />
    </button>

    <div class="carousel">
      <div class="carousel-track" :style="{ transform: translateValue }">
        <div v-for="(group, groupIndex) in groupedButtons" :key="groupIndex" class="carousel-group">
          <div v-for="(button, index) in group" :key="index" 
               class="carousel-slide" 
               :style="{ width: `${slideWidth}px` }">
            <a :href="button.route" class="carousel-button" @click.prevent="button.action">
              <img :src="button.icon" :alt="button.alt" class="button-icon" />
              <span class="text-button">{{ button.text }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Botão para navegar para o próximo slide -->
    <button 
      @click="nextSlide" 
      class="carousel-control next-links" 
      :disabled="isAtEnd"
      :class="{ disabled: isAtEnd }"
      aria-label="Next slide"
    >
      <img class="setas-navegacao" src="@/assets/icons/seta-right.svg" alt="Seta para a direita" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    buttons: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      slideWidth: 0,
      slidesPerView: 5,
      groupedSlides: []
    };
  },
  computed: {
    // Agrupa os slides em conjuntos baseados no slidesPerView
    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.buttons.length; i += this.slidesPerView) {
        groups.push(this.buttons.slice(i, i + this.slidesPerView));
      }
      return groups;
    },
    isAtEnd() {
      return this.currentIndex >= this.groupedButtons.length - 1;
    },
    translateValue() {
      return `translateX(-${this.currentIndex * 100}%)`;
    }
  },
  methods: {
    calculateSlideWidth() {
      if (this.$refs.carouselRef) {
        const containerWidth = this.$refs.carouselRef.offsetWidth - 140; // Subtract navigation buttons width
        this.slideWidth = Math.floor(containerWidth / this.slidesPerView);
      }
    },
    updateSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 768) {
        this.slidesPerView = 1;
      } else if (width <= 1200) {
        this.slidesPerView = 2;
      } else if (width <= 1439) {
        this.slidesPerView = 3;
      } else {
        this.slidesPerView = 5;
      }
      
      this.calculateSlideWidth();
      this.adjustCurrentIndex();
    },
    adjustCurrentIndex() {
      const maxIndex = Math.max(0, Math.ceil(this.buttons.length / this.slidesPerView) - 1);
      this.currentIndex = Math.min(this.currentIndex, maxIndex);
    },
    nextSlide() {
      if (!this.isAtEnd) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  },
  mounted() {
    this.updateSlidesPerView();
    window.addEventListener('resize', this.updateSlidesPerView);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSlidesPerView);
  }
};
</script>

<style>
/* src="@/assets/css/carousel.css" */
@import '../../assets/css/variables.css';

.carousel-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
  grid-column: span 3; /* Spans all 3 columns */
  -webkit-box-ordinal-group: 4;
  -ms-flex-order: 3;
  order: 3;
}

.carousel {
  width: calc(100% - 140px);
  overflow: hidden;
  margin: 0 20px;
  height: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.carousel-track {
  display: flex;
  transition: transform 0.3s ease;
  width: 100%;
}

.carousel-group {
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  gap: 20px;
}

.carousel-slide {
  flex: 1;
  min-width: 0;
  padding: 0 10px;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .carousel-group {
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .carousel-slide {
    width: calc(100% - 20px) !important;
  }
  
  .carousel {
    width: calc(100% - 80px);
  }
  
}

/* Modified media queries for grid layout */
@media (max-width: 1920px) {
  .carousel-container {
    max-width: 1493px; /* 383px + 580px + 384px + 146px gaps */
  }
}

@media (max-width: 1440px) {
  .carousel-container {
    max-width: 100%;
    margin: 30px 20px;
  }
}

.carousel {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: auto;
  height: 200px;
  -webkit-box-ordinal-group: 4;
  -ms-flex-order: 3;
  order: 3;
  grid-column: span 3;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.carousel-wrapper {
  width: calc(100% - 425px); /* 70px para cada botão de navegação */
  margin: 0 auto;
  overflow: hidden;
}

.carousel-container {
  display: flex;
  transition: transform 0.3s ease;
  height: 180px;
  align-items: center;
}

.carousel-slide {
  flex: 0 0 306px;
  padding: 0 10px;
  box-sizing: border-box;
}

.carousel-button {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--header-height);
  padding: 8px 10px;
  background-color: #DFDFDF;
  color: #282828;
  text-decoration: none;
  border-radius: var(--border-radius);
  transition: all 0.3s ease;
  margin-bottom: 0 !important;
}

.text-button {
  text-align: left;
}

.carousel-button:hover {
  filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.35));
}

.button-icon {
  margin-right: 28px;
  width: 40px;
  height: 47px;
  flex-shrink: 0;
}

.carousel-control {
  position: absolute;
  top: 39%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px;
  z-index: 10;
  transition: opacity 0.3s ease;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.setas-navegacao {
  height: 35px;
}

.carousel-control.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.prev-links {
  left: -70px;
}

.next-links {
  right: -70px;
}

a:hover {
  color: var(--primary-color);
  text-decoration: none;
} 

@media (max-width: 1920px) {
  .carousel-wrapper {
    width: calc(100% - 410px);
  }
}

@media (max-width: 1800px) {
  .carousel-wrapper {
    width: calc(100% - 410px);
  }
}

@media (max-width: 1746px) {
  .carousel-wrapper {
    width: calc(100% - 320px); 
  }
  .prev-links {
    /* left: 100px; */
  }
  
  .next-links {
    /* right: 100px; */
  }
}

@media (max-width: 1650px) {
  .carousel-wrapper {
    width: calc(100% - 230px);
  }
}

@media (max-width: 1537px) {
  .carousel-wrapper {
    width: calc(100% - 250px); 
  }
  .prev-links {
    /* left: 0px; */
  }
  
  .next-links {
    /* right: 0px; */
  }
}

@media (max-width: 1440px) {
  .carousel-wrapper {
    width: calc(100% - 320px);
  }
  .prev-links {
    left: -40px;
  }
  
  .next-links {
    right: -40px;
  }
}

@media (max-width: 1366px) {
  .carousel-wrapper {
    width: calc(100% - 250px);
  }
}

@media (max-width: 1280px) {
  .carousel-wrapper {
    width: calc(100% - 260px);
  }
  .prev-links {
    /* left: 60px; */
  }
  
  .next-links {
    /* right: 60px; */
  }
}

@media (max-width: 1098px) {
  .carousel-wrapper {
    width: calc(100% - 380px);
  }
  .prev-links {
    /* left: 120px; */
  }
  
  .next-links {
    /* right: 120px; */
  }
}

@media (max-width: 1024px) {
  .carousel-wrapper {
    width: calc(100% - 306px);
  }
}

@media (max-width: 960px) {
  .carousel-wrapper {
    width: calc(100% - 242px);
  }
  .prev-links {
    /* left: 60px; */
  }
  
  .next-links {
    /* right: 60px; */
  }
}

@media (max-width: 854px) {
  .carousel-wrapper {
    width: calc(100% - 450px);
  }
}

@media (max-width: 768px) {
  .carousel-wrapper {
    width: calc(100% - 355px);
  }
  .prev-links {
    left: 0px;
  }
  
  .next-links {
    right: 0px;
  }
}

@media (max-width: 720px) {
  .carousel-wrapper {
    width: calc(100% - 300px);
  }
}

@media (max-width: 640px) {
  .carousel-wrapper {
    width: calc(100% - 230px);
  }
  .prev-links {
    /* left: 50px; */
  }
  
  .next-links {
    /* right: 50px; */
  }
}

@media (max-width: 540px) {
  .carousel-wrapper {
    width: calc(100% - 135px);
  }
}

@media (max-width: 480px) {
  .carousel-wrapper {
    width: calc(100% - 130px);
  }
  .prev-links {
    left: -20px;
  }
  
  .next-links {
    right: -20px;
  }
}

@media (max-width: 414px) {
  .carousel-slide {
    flex: 0 0 280px;
  }
  .carousel-wrapper {
    width: calc(100% - 95px);
  }
}

@media (max-width: 385px) {
  .carousel-slide {
    flex: 0 0 280px;
  }
  
  .carousel-wrapper {
    width: calc(100% - 65px);
  }
  
  .carousel-control {
    width: 20px;
  }
  .next-links {
    right: -5px;
  }
  .prev-links {
    left: -5px;
  }
}

@media (max-width: 320px) {
  .carousel-slide {
    flex: 0 0 230px;
  }

  .carousel-wrapper {
    width: calc(100% - 50px);
  }
}

@media (min-width: 1201px) and (max-width: 1439px) {
  .carousel-group {
    gap: 5px;
  }
  
  .carousel-slide {
    flex: 0 0 calc(33.333% - 10px);
  }
}

@media (min-width: 1440px) {
  .carousel-slide {
    flex: 0 0 calc(20% - 16px);
  }
  
  .carousel-group {
    gap: 0px;
  }
  .next-links {
    right: -20px;
  }
  .prev-links {
    left: -20px;
  }

}

</style>